<script>
  import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
  import Icon from 'fa-svelte';
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { getTrad } from './js/AppState';
  import SGMSApi from './js/SGMSApi';
  const dispatch = createEventDispatcher();


  function acceptGA(e) {
    SGMSApi.sendActionEvent(e, "AcceptCookies")
    dispatch('close')
  }

  function deactivateGA(e) {
    window['ga-disable-UA-100426389-9'] = true;
    SGMSApi.sendActionEvent(e, "DenyCookies")
    dispatch("close")
  }
</script>

<div class="rgpd-screen" transition:fade>
  <div class="rgpd-popup">
    <div class="close" on:click={acceptGA} />
    <div class="content">
      <div class="blue">
        <div>{$getTrad("Ecran_rgpd_01")}</div>
        <div><a target="_blank" href={$getTrad("cookie_policy_link")}>{$getTrad("Ecran_rgpd_02")}</a></div>

        <button on:click={deactivateGA}>
          {$getTrad("ecran_rgpd_refus")}
          <span class="i"><Icon icon={faArrowRight}/></span>
        </button>
      </div>
      <div class="white">
        <div>{$getTrad("Ecran_rgpd_03")}</div>
        <div><a target="_blank" href={$getTrad("data_rights_link")}>{$getTrad("Ecran_rgpd_04")}</a></div>
      </div>
    </div>
  </div>
</div>


<style>
  .rgpd-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(45, 68, 136, 0.8);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 10;
  }

  .rgpd-popup {
    position: relative;
    max-width: 410px;
    margin: 30px;
    margin-top: -50px;

    display: flex;
    flex-direction: column;

    border-radius: 30px 30px 0 0;
    padding-bottom: 0;

    color: #fff;
    background: #00a7e6;

    text-align: left;

  }

  .content { overflow-y: auto; }

  .content a {
    color: inherit;
    text-decoration: underline;
  }

  .blue {
    padding: 40px;
    padding-bottom: 10px;
  }
  .white {
    padding: 10px 40px;
    padding-bottom: 0;

    background: #FFF;
    color: #000;
  }

  .rgpd-popup::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;

    height: 100px;
    background: url('../images/white-bottom.png') no-repeat center center;
    background-size: 100% 100%;
  }

  .close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
    background: url('../images/closepopup.svg') no-repeat center center;
  }


  button .i{
    margin-left: 10px;

  }
  button:hover {text-decoration: underline;}
  button {
    background: none;
    border: none;
    color: #fff;
    font-weight: bold;
    font-size: 1em;
    margin: 0;
    padding: 0;

    padding: 10px;
    padding-left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }


  @media screen and (max-width: 800px) {
    .rgpd-popup {
      font-size: 12px;
      max-height: 70%;

    }
  }
</style>
